import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import { SketchPicker } from 'react-color';
import InputRange from 'react-input-range';
import Switch from 'react-toggle-switch';

import 'react-select/scss/default.scss';
import 'react-input-range/lib/css/index.css';
import 'react-toggle-switch/dist/css/switch.min.css';
import './SlideSettings.scss';

import reducerStore from '../../reducers/reducerStore';

class slideSettings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            values: [],
        };

        this.titleChange = this.titleChange.bind(this);
        this.companyLogoChange = this.companyLogoChange.bind(this);
        this.logoSelected = this.logoSelected.bind(this);
        this.bgImageChange = this.bgImageChange.bind(this);
        this.bgColorChange = this.bgColorChange.bind(this);

        this.numberDividedByChange = this.numberDividedByChange.bind(this);
        this.numberPointChange = this.numberPointChange.bind(this);

        this.rangeSlideDragged = this.rangeSlideDragged.bind(this);
        this.rangeSlideDraggedText = this.rangeSlideDraggedText.bind(this);
    }

    componentDidMount() {
        const slide = this.props.slide;
        slide.competitionSettings = {};

        $.get('/api/activityTypes/all').then((resp) => {
            const entities = resp.map((obj) => {
                return (
                    <option
                        key={obj.id}
                        value={`${obj.name};${obj.parent}`}
                    >
                        {obj.name}
                    </option>);
            });

            entities.push(<option key="order" value="Order;order">Order</option>);
            entities.unshift(<option key="choose" value="null">Välj entitet</option>);
            this.setState({
                slide,
                entities,
            });
        });

        $.get('/api/competition/roles').then((resp) => {
            const roles = resp.map(obj => (<option
                key={obj.id}
                value={`${obj.id};${obj.name}`}
            >
                {obj.name}
            </option>));

            roles.unshift(<option key="all_roles" value="all">Samtliga roller</option>);

            this.setState({
                rolesSelectionList: roles,
            });
        });

        $.get('/api/competition/users').then((resp) => {
            const users = resp.map(obj => (<option
                key={obj.id}
                value={`${obj.id};${obj.name}`}
            >
                {obj.name}
            </option>));

            users.unshift(<option key="all_users" value="all">Samtliga användare</option>);

            this.setState({
                usersSelectionList: users,
            });
        });
    }

    // Returns black or white depending on the provided color
    getTextColor(_hex) {
        let hex = _hex.substring(1);
        // We always want 6 digit hex
        if (hex.length === 3) {
            hex = `${hex}${hex}`;
        }

        const rgb = parseInt(hex, 16);   // convert rrggbb to decimal
        const r = (rgb >> 16) & 0xff;  // extract red
        const g = (rgb >> 8) & 0xff;  // extract green
        const b = (rgb >> 0) & 0xff;  // extract blue

        const luma = (0.2126 * r) + (0.7152 * g) + (0.0722 * b); // per ITU-R BT.709

        if (luma < 150) {
            return '#ffffff';
        }

        return '#000000';
    }

    titleChange(e) {
        const slide = this.props.slide;
        slide.title = e.target.value;
        this.updateSlide(slide);
    }

    companyLogoChange() {
        const slide = this.props.slide;
        slide.showCompanyLogo = !slide.showCompanyLogo;

        this.updateSlide(slide);
    }

    bgImageChange(e) {
        const slide = this.props.slide;
        slide.backgroundImage = e.target.value;

        this.updateSlide(slide);
    }

    bgColorChange(color) {
        const slide = this.props.slide;
        slide.custom.bgColor = color.hex;
        this.updateSlide(slide);
    }

    logoSelected(url) {
        const slide = this.props.slide;
        slide.custom.logo = url;
        this.updateSlide(slide);
    }

    updateSlide(slide) {
        reducerStore.dispatch({ type: 'UPDATE SLIDES', freshSlides: slide });
    }

    numberDividedByChange(e) {
        const splittedStrings = e.target.value.split(';');
        _.map(this.props.slide.competitionSettings.selectedPoints, (obj) => {
            if (obj.entity === splittedStrings[0]) {
                obj.dividedBy = splittedStrings[1];
            }

            return obj;
        });
    }

    numberPointChange(e) {
        const splittedStrings = e.target.parentNode.id.split(';');
        _.map(this.props.slide.competitionSettings.selectedPoints, (obj) => {
            if (obj.entity === splittedStrings[0]) {
                obj.value = e.target.valueAsNumber;
            }

            return obj;
        });
    }

    rangeSlideDragged(value) {
        const slide = this.props.slide;
        slide.custom.bgOpacity = value;

        this.updateSlide(slide);
    }

    rangeSlideDraggedText(value) {
        const slide = this.props.slide;
        slide.custom.bgOpacity = parseInt(value.target.value, 10);

        this.updateSlide(slide);
    }

    render() {
        const { slide, deleteSlide, companyProfile, companyOptions, saveSlide } = this.props;

        let displayColorPicker;
        if (this.props.showPicker) {
            displayColorPicker = (<SketchPicker
                color={slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg}
                onChangeComplete={this.bgColorChange}
            />);
        } else {
            displayColorPicker = (<div
                className="color-box"
                onClick={(e) => {
                    reducerStore.dispatch({ type: 'TOGGLE COLOR PICKER', open: true });
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }}
                style={{
                    backgroundColor: slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg,
                    color: this.getTextColor(slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg),
                    padding: '10px 15px',
                    borderRadius: '3px',
                    display: 'inline-block',
                    width: 'auto',
                    textAlign: 'center',
                    margin: '5px 0',
                }}
            >
                {slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg}
            </div>);
        }

        return (
            <div 
                className="general settings-card"
                onClick={(e) => {
                    reducerStore.dispatch({ type: 'TOGGLE COLOR PICKER', open: false });
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }}>
                <div className="holder">
                    <div className="row">
                        <div className="setting">
                            <span>Titel på sliden</span>
                            <input
                                autoFocus
                                id="slideTitle"
                                type="text"
                                className="form-control"
                                value={slide.title || ''}
                                onChange={this.titleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="setting">
                            <span>Bakgrundsbild</span>
                            <input
                                id="bgImage"
                                type="text"
                                className="form-control"
                                value={slide.backgroundImage || ''}
                                onChange={this.bgImageChange}
                            />
                        </div>
                        <div className="description">
                            <span>
                                Ange länken till bilden. Bilden används som bakgrundsbild
                                 endast för denna slide.
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="setting opacity-group">
                            <span>Opacitet på bilden</span>
                            <InputRange
                                minValue={0}
                                maxValue={100}
                                value={slide.custom && slide.custom.bgOpacity ? slide.custom.bgOpacity : 50}
                                onChange={this.rangeSlideDragged}
                            />
                            <input
                                type="text"
                                className="form-control"
                                name="opacity-value"
                                value={slide.custom && slide.custom.bgOpacity ? slide.custom.bgOpacity : 50}
                                onChange={this.rangeSlideDraggedText}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div 
                            className="setting"
                            >
                            <span>Bakgrundsfärg</span><br />
                            <div
                                style={{display: 'inline-block'}} 
                                onClick={(e) => {
                                e.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                            }}>
                                {displayColorPicker}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="setting">
                            <div className="checkbox">
                                <label htmlFor="company-profile-checkbox">
                                    <Switch
                                        onClick={this.companyLogoChange}
                                        on={slide.showCompanyLogo || false}
                                    />
                                    <span className="sub special">Visa företagslogotyp</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <button onClick={saveSlide} className="btn slide-save-btn">Spara</button>
                </div>
            </div>
        );
    }
}

slideSettings.propTypes = {
    slide: React.PropTypes.object,
    sliderData: React.PropTypes.func,
    compColors: React.PropTypes.object,
    deleteSlide: React.PropTypes.func,
    companyProfile: React.PropTypes.object,
    companyOptions: React.PropTypes.object,
    showPicker: React.PropTypes.bool,
};

export default slideSettings;



/** WEBPACK FOOTER **
 ** ./client/components/SlideSettingsModal/SlideSettings.jsx
 **/